<template>
  <v-flex>
    <list-customers
      v-show="existingQantas"
      ref="QBRCustomers"
      :existing-qantas="existingQantas"
      :list-customer-open="existingQantas"
      :loading="loading"
      @closed="closeScreen"
    ></list-customers>
    <v-dialog v-model="showNotification" hide-overlay persistent width="1000">
      <v-title>Notifications</v-title>

      <v-card>
        <v-container fluid grid-list-lg>
          <v-layout row wrap>
            <v-flex xs12>
              <v-card color="white">
                <v-card-title primary-title>
                  <div>
                    <div class="headline underline">Notification Header</div>
                    <span>Notification text goes here</span>
                  </div>
                </v-card-title>
                <v-card-actions class="pa-3">
                  <v-spacer></v-spacer>
                  <v-btn icon color="primary">
                    <v-icon>link</v-icon>
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-flex>
            <v-flex xs12>
              <v-card color="white">
                <v-card-title primary-title>
                  <div>
                    <div class="headline underline">
                      Notification Header Admin
                    </div>
                    <span>Notification text goes here</span>
                  </div>
                </v-card-title>
                <v-card-actions class="pa-3">
                  <v-spacer></v-spacer>

                  <v-btn icon color="primary">
                    <v-icon>link</v-icon>
                  </v-btn>
                  <v-btn icon color="red">
                    <v-icon color="white">delete</v-icon>
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-flex>
            <v-flex xs12>
              <v-card color="light-grey">
                <v-card-title primary-title>
                  <vonex-text
                    label="Enter Heading Here"
                    name="notifHeading"
                    :options="fieldConditions"
                  ></vonex-text>
                  <!-- <v-text-field label="Enter Heading Here"></v-text-field> -->
                </v-card-title>
                <v-card-text>
                  <vonex-text
                    label="Enter text here"
                    name="notifText"
                    :options="fieldConditions"
                  ></vonex-text>
                  <!-- <v-text-field label="Enter text here"></v-text-field> -->
                  <vonex-text
                    label="Enter link here"
                    name="notifLink"
                    :options="fieldConditions"
                    prepend-icon="link"
                  ></vonex-text>
                  <!-- <v-text-field prepend-icon="link" label="Enter link here" /> -->
                </v-card-text>
                <v-card-actions class="pa-3">
                  <v-spacer></v-spacer>
                  <v-btn color="primary" dark>Save</v-btn>
                  <v-btn color="light-grey">Cancel</v-btn>
                </v-card-actions>
              </v-card>
            </v-flex>

            <v-layout row wrap>
              <v-spacer></v-spacer>
              <v-btn color="#2f5578" disabled>Add New Notification</v-btn>
              <v-btn color="light-grey">Close</v-btn>
            </v-layout>
          </v-layout>
        </v-container>
      </v-card>
    </v-dialog>

    <v-dialog v-model="isLoading" hide-overlay persistent width="300">
      <v-card color="primary" dark>
        <v-card-text>
          Please stand by
          <v-progress-linear
            indeterminate
            color="white"
            class="mb-0"
          ></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog v-model="sqSent" persistent width="500">
      <v-card>
        <v-title>SQ Request sent</v-title>
        <v-card-text>
          <v-flex xs12>
            <p class="headline">
              Your Service Qualification Request has been submitted to our
              Support Team on ticket #{{ lastSQTicket }}. You will receive a
              response within 24 hours.
            </p>
          </v-flex>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn large color="light-grey" @click.native="sqSent = false">
            Close
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="requestDialog" persistent>
      <v-card>
        <v-title>Service Qualification</v-title>
        <v-card-text>
          <UtilityAddressFinder
            :add="true"
            :send="true"
            @sendAddress="sendSQ"
            @close="requestDialog = false"
          ></UtilityAddressFinder>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="showCustomers"
      scrollable
      persistent
      :overlay="false"
      max-width="1000px"
      transition="dialog-transition"
    >
      <v-card style="background: #fff">
        <v-title>Add Order to Existing Customer</v-title>
        <v-card-text>
          <customer-table
            v-if="showCustomers"
            :customer-data="customerData || []"
            :order-type="selectedOrderType"
            :loading="customerLoading"
            :total-items="totalItems"
            @existingOrder="existingOrder"
            @cancelOrder="cancelOrder"
            @updatePage="updateCustomerList"
          ></customer-table>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="light-grey" @click="showCustomers = false">
            Cancel
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="colDialog"
      max-width="1000px"
      max-height="80vh"
      persistent
    >
      <change-lessee-dialogs
        :dialog="colDialog"
        @close="closeCOLDialog()"
      ></change-lessee-dialogs>
    </v-dialog>

    <v-layout row wrap>
      <v-flex xs12>
        <order-type
          @qantas="NewOrder('Qantas')"
          @business="NewOrder('Business')"
          @residential="NewOrder('Residential')"
          @financedHardware="NewOrder('Finance')"
          @existingFinanced="
            loadCustomers('Business');
            showExistingOrderDialog(4);
          "
          @standard="
            loadCustomers('Business');
            showExistingOrderDialog(0);
          "
          @existingResidential="
            loadCustomers('Residential');
            showExistingOrderDialog(0);
          "
          @upgradeQBR="getEligibleQBR()"
          @additionalQBR="
            //loadCustomers();
            addExistingQantas()
          "
          @coa="
            loadCustomers('Both');
            showExistingOrderDialog(1);
          "
          @col="colProcess"
          @sq="requestDialog = true"
        ></order-type>
      </v-flex>
      <v-flex xs12></v-flex>
      <v-title>
        View Existing Orders
        <v-btn
          color="secondary"
          small
          @click="
            showExisting = !showExisting;
            loadOrders();
          "
        >
          {{ showExisting ? 'Hide' : 'Show' }}
        </v-btn>
        <v-btn
          v-if="overDueOrders.length > 0 && attention === true"
          color="secondary"
          small
          @click="updateAttentionStatus()"
        >
          Reset View
        </v-btn>
        <v-btn
          v-if="overDueOrders.length > 0"
          dark
          small
          color="secondary"
          :disabled="attention"
          @click="
            attention = true;
            resetView = false;
          "
        >
          Attention Required ({{ overDueOrders.length }})
          <v-tooltip bottom color="primary">
            <template v-slot:activator="{ on }">
              <v-icon class="ml-1" v-on="on">help</v-icon>
            </template>
            <div style="font-size: 18px; width: 300px" class="px-2 pt-2">
              <p class="font-weight-black">Attention Required</p>
              <p>
                Orders that require attention have been in the
                <span class="font-weight-black">New</span>
                or
                <span class="font-weight-black">In Progress</span>
                status for
                <span class="font-weight-black">over one week</span>
                . Please review or cancel these orders.
              </p>
              <p>
                Once an order has been in the status of
                <span class="font-weight-black">New</span>
                or
                <span class="font-weight-black">In Progress</span>
                for
                <span class="font-weight-black">over one month</span>
                , it’s status will automatically be changed to
                <span class="font-weight-black">Cancelled</span>
                .
              </p>
            </div>
          </v-tooltip>
        </v-btn>
      </v-title>

      <v-flex v-if="showExisting" xs12 md12 lg12 style="margin-top: 30px">
        <label>
          Choose order from list below and click
          <v-icon color="secondary">restore</v-icon>
        </label>
        <component
          :is="quoteToolFlag ? 'OrdersTable1723' : 'ordersTable'"
          :order-data="orderData"
          :attention="attention"
          :loading="loading"
          :paginated-data="paginatedData"
          @existingOrder="existingOrder"
          @update="orderUpdate"
          @resubmitOrder="resubmitOrder"
          @cancelOrder="cancelOrder"
          @resetToEdit="reset"
          @reprocessOrder="reprocessOrder"
          @uploadToTicket="uploadFilesToTicket"
          @updatePage="getPaginatedOrders"
        ></component>
      </v-flex>
    </v-layout>
    <message-alert :component="message"></message-alert>
    <v-layout row justify-center>
      <v-dialog v-model="dialog" persistent max-width="290">
        <v-card>
          <v-card-title class="headline">
            Unfinished order detected!
            <br />
            Forget it, or continue?
          </v-card-title>
          <v-card-text>
            From this point you may continue any previous order (not yet signed
            and submitted)
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="green darken-1"
              flat
              @click.native="closeRetrieve(false)"
            >
              Forget it
            </v-btn>
            <v-btn
              color="green darken-1"
              flat
              @click.native="closeRetrieve(true)"
            >
              Continue
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-layout>
    <v-layout row justify-center>
      <v-dialog v-model="retrieved" persistent max-width="290">
        <v-card>
          <v-card-title v-if="loading" class="headline">
            Getting {{ isQuote ? 'quote' : 'order' }}
          </v-card-title>
          <v-card-title v-else class="headline">
            {{ isQuote ? 'Quote' : 'Order' }} Retrieved
          </v-card-title>
          <v-card-text>
            Please navigate to the relevant section of the order using the
            navigation bar to the left.
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="primary"
              :disabled="loading"
              @click.native="closeRetrieve(retrieved)"
            >
              OK
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-layout>

    <v-layout row justify-center>
      <v-dialog v-model="cancel" persistent max-width="290">
        <v-card>
          <v-card-title class="headline">
            Cancel Order {{ orderID }}?
          </v-card-title>
          <v-card-text>Are you sure you want to cancel this order?</v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="primary" @click.native="closeCancel(true)">Yes</v-btn>
            <v-btn color="light-grey" @click.native="closeCancel(False)">
              No
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-layout>

    <v-dialog v-model="reprocessOrderDialog" persistent width="300">
      <v-card color="primary" dark>
        <v-card-text>
          Reprocessing order. Please wait...
          <v-progress-linear
            indeterminate
            color="white"
            class="mb-0"
          ></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-flex>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import {
  mapOrderMultiRowFields,
  mapCustomerFields,
} from '../store/modules/orders';
const { mapState: mapOrderState } = createNamespacedHelpers(`orders`);
const {
  mapActions: mapOrderActions,
  mapMutations: mapOrderMutations,
  mapGetters: mapOrderGetters,
} = createNamespacedHelpers(`orders`);
const {
  mapGetters: mapCustomerGetters,
  mapMutations: mapCustomerMutations,
  mapActions: mapCustomerActions,
} = createNamespacedHelpers(`orders/customer`);

import ordersTable from './ordersTable';
import customerTable from './customerTable';
import { httpError } from '../models/httpError';

import UtilityAddressFinder from '@/components/utility/utility-address-finder';
import ListCustomers from '@/components/qantas/list-customers';
import ChangeLesseeDialogs from '@/components/change-lessee-dialogs';
import OrderType from '@/components/pages/create-order/order-type';
import OrdersTable1723 from '@/components/ordersTable-1723';
import { DirectDebit } from '../models/DirectDebit';
const { mapGetters: mapFeatureFlagGetters } =
  createNamespacedHelpers(`orders/featureFlag`);

export default {
  name: 'OrderCreate',
  components: {
    ordersTable,
    customerTable,
    UtilityAddressFinder,
    ListCustomers,
    OrderType,
    ChangeLesseeDialogs,
    OrdersTable1723,
  },
  data() {
    return {
      showExisting: false,
      existingQantas: false,
      attention: false,
      showModal: false,
      custID: null,
      orderID: null,
      orderData: [],
      customerData: [],
      paginatedData: {},
      totalItems: undefined,
      custType: '',
      pagination: {
        pageNo: 1,
        pageSize: 10,
      },
      dialog: false,
      retrieved: false,
      cancel: false,
      active: null,
      isLoading: false,
      loading: true,
      customerLoading: false,
      lastSQTicket: '',
      sqSent: false,
      showCustomers: false,
      dropdown_icon: null,
      remote: false,
      requestDialog: false,
      editedOrder: {},
      selectedOrderType: 0,
      selectedProcessType: false,
      showNotification: false,
      resetView: false,
      colDialog: false,
      orderTypes: [
        {
          text: 'Normal',
          callback: () => {
            this.showExistingOrderDialog(0);
          },
        },
        {
          text: 'Change of Address',
          callback: () => {
            this.showExistingOrderDialog(1);
          },
        },
        // {
        //   text: "Change of Lessee",
        //   callback: () => {
        //     this.showExistingOrderDialog(2);
        //   },
        // },
        {
          text: 'Qantas Business',
          callback: () => {
            this.showExistingOrderDialog(3);
          },
        },
        {
          text: 'Financed Hardware',
          callback: () => {
            this.showExistingOrderDialog(4);
          },
        },
      ],
      attentionDialog: false,
      customerType: false,
      directDebit: new DirectDebit(),
    };
  },
  // watch: {
  //   customerData: function () {
  //     if (this.customerData === null) {
  //       this.showCustomers = false;
  //     } else this.customerLoading = false;
  //   },
  // },
  computed: {
    ...mapCustomerFields(['customer.customerID']),
    ...mapFeatureFlagGetters(['allFlags']),
    // ...mapCustomerGetters(['customerData']),
    ...mapOrderMultiRowFields({
      orders: 'rows',
    }),
    ...mapOrderState([
      'message',
      'company',
      'customer',
      'dealer',
      'isResidential',
      'reprocessOrderDialog',
      'rows',
    ]),
    ...mapOrderGetters([
      'hasDealer',
      'hasOrder',
      'isAdmin',
      'quoteToolFlag',
      'isQuote',
      'isDirectSales',
    ]),
    isImport: function () {
      if (this.orderID > 0) {
        return true;
      }
      return false;
    },
    submitted: function () {
      if (this.message.httpStatus === 200) {
        return 'alert alert-success';
      } else return 'alert alert-danger';
    },
    overDueOrders: function () {
      if (!this.orderData || this.orderData.length == 0) return [];
      let weekAgo = new Date();
      weekAgo.setDate(weekAgo.getDate() - 7);
      return this.orderData
        .filter((order) => order.orderStatus === 0 || order.orderStatus === 1)
        .filter((order) => new Date(order.createdDate) < weekAgo);
    },
  },
  mounted() {
    this.$el.addEventListener(
      'softphoneOrder',
      () => (this.showCustomers = false)
    );
    this.setReprocessOrderDialog(false);
  },

  methods: {
    ...mapCustomerActions([
      'getCustomer',
      'resetCustomer',
      'listCustomers',
      'updateCustomer',
    ]),
    ...mapCustomerMutations(['setDealerCustomers']),
    ...mapOrderActions([
      'addOrder',
      'getOrder',
      'updateOrder',
      'updateOrderType',
      'resetOrder',
      'listOrders',
      'removeOrder',
      'listAllOrders',
      'paginatedlistAllOrders',
      'setMessage',
      'resubmitOrderToKayako',
      'getTrainingLinks',
      'sendSQRequest',
      'sendSQRequestNew',
      'resetToEdit',
      'reprocessOrder',
      'uploadFilesToTicket',
      'setMessage',
      'updateOrderSignedDate',
      'updateDirectDebit',
      'getDirectDebit',
    ]),
    ...mapOrderMutations([
      'setResidential',
      'setOrderType',
      'setOrderStatus',
      'setOrderTicket',
      'setOrderEnvelope',
      'setReprocessOrderDialog',
      'setProgress',
      'setExistingCust',
      'setSignedDate',
      'setIsQuote',
    ]),
    colProcess() {
      this.$store.dispatch('orders/resetOrder');
      if (this.$ld.flags && this.$ld.flags.changeOfLessee) {
        this.loadCustomers('Both');
        this.colDialog = true;
        this.$store.commit('orders/changeLessee/setCreateOnly', true);
      } else {
        window.open(
          'https://vonex.com.au/wp-content/uploads/2021/10/Change-of-Lessee.pdf',
          '_blank'
        );
      }
    },
    closeScreen() {
      this.existingQantas = false;
      this.showCustomers = false;
    },
    addExistingQantas() {
      this.existingQantas = true;
      this.$refs.QBRCustomers.getExisting();
    },
    getEligibleQBR() {
      let vm = this;
      vm.custType = '';
      vm.existingQantas = true;
      vm.$refs.QBRCustomers.getEligible();
    },
    loadCustomers(customerType) {
      let vm = this;
      vm.custType = customerType;
      vm.customerLoading = true;
      vm.customerData = [];
      let payload = {
        customerType: customerType,
        pagination: vm.pagination,
        keyword: '',
      };
      vm.getCustomerList(payload);
    },
    updateCustomerList(data) {
      let vm = this;
      vm.customerLoading = true;
      vm.pagination.pageSize = data.pageSize;
      vm.pagination.pageNo = data.pageNo;
      vm.customerData = [];

      vm.getCustomerList({
        dealerID: data.dealerID,
        customerType: vm.custType,
        pagination: vm.pagination,
        keyword: data.keyword,
      });
    },
    getCustomerList(data) {
      let vm = this;
      this.listCustomers(data)
        .then((data) => {
          // vm.setDealerCustomers(data);
          vm.dealerID = data.dealerID;
          vm.customerData = data.customers;
          vm.totalItems = data.total;
          vm.customerLoading = false;
        })
        .catch((err) => {
          vm.customerLoading = false;
          this.setMessage(
            new httpError({
              message: 'Unable to retrieve Customers ' + err.message,
              httpError: 500,
            })
          );
        });
    },
    loadOrders() {
      let vm = this;
      if (!vm.showExisting) return;
      vm.setMessage(new httpError());
      vm.loading = true;
      vm.getDealerOrders()
        .then(() => {
          vm.loading = false;
        })
        .catch(() => {
          vm.loading = false;
        });
    },
    getPaginatedOrders(query) {
      let vm = this;
      vm.orderData = [];
      vm.loading = true;
      vm.paginatedlistAllOrders({
        orderID: 0,
        statusFilters: query.statusFilters,
        orderType: query.orderType,
        isImpersonating: vm.$store.state.impersonate.viewbarEnabled,
        isAdmin: vm.isAdmin,
        isQuote: query.isQuote,
        keyword: query.keyword,
        dealerID: query.dealerID,
        pagination: {
          pageNo: query.pageNo,
          pageSize: query.pageSize,
          orderBy: query.orderBy,
          descending: query.descending,
        },
      }).then(function (data) {
        vm.paginatedData = data;
        vm.orderData = data.data;
        vm.loading = false;
      });
    },
    getDealerOrders: function () {
      return new Promise((resolve) => {
        let vm = this;
        vm.orderData = [];
        vm.getPaginatedOrders({
          statusFilters: [0, 1],
          pageNo: 1,
          pageSize: 10,
          keyword: '',
          dealerID: 0,
          orderType: '',
          isQuote: false,
        });
        resolve();
      });
    },
    CreateNewCustomer: function () {
      let vm = this;
      vm.dialog = false;
      this.resetCustomer().then(() => {
        vm.$router.push({
          path: `/create-customer`,
        }); // /${customerId}` })
      });
    },
    reset(value) {
      let vm = this;
      vm.resetToEdit(value.orderID).then(() => {
        vm.getDealerOrders();
      });
    },
    orderUpdate(value) {
      let vm = this;
      if (value.orderStatus === 2) {
        vm.setSignedDate(new Date().toJSON());
        vm.updateOrderSignedDate(value.orderID).then(() => {
          vm.loadOrders();
        });
      }
      vm.setOrderStatus(value.orderStatus);
      vm.setOrderTicket(value.kayakoConversation);
      vm.setOrderType(value.orderType);
      vm.setOrderEnvelope(value.envelopeID);
      vm.updateOrder(value);
    },
    cancelOrder(orderID) {
      this.orderID = orderID;
      this.cancel = true;
    },
    resubmitOrder(orderID) {
      this.resubmitOrderToKayako(orderID)
        .then(() => {})
        .catch(() => {});
    },
    showExistingOrderDialog(type) {
      this.showCustomers = true;
      this.customerData = [];
      this.selectedOrderType = type;
    },
    closeCancel(el) {
      let vm = this;
      vm.cancel = false;
      if (el == true)
        vm.removeOrder(vm.orderID).then(() => {
          vm.getDealerOrders();
        });
    },
    NewOrder: function (orderType) {
      let vm = this;
      vm.dialog = false;
      vm.resetOrder()
        .then(() => {
          let isBusiness = orderType === 'Business';
          let isQantas = orderType === 'Qantas';
          let isFinance = orderType === 'Finance';

          let isResi = isBusiness || isQantas || isFinance ? false : true;
          vm.setResidential(isResi);

          if (orderType == 'Qantas') {
            vm.setOrderType(3);
          } else if (orderType == 'Finance') {
            vm.setOrderType(4);
          } else {
            vm.setOrderType(0);
          }

          vm.$router.push({
            path: ['Business', 'Qantas', 'Finance'].includes(orderType)
              ? `/create-company`
              : `/create-customer`,
          });
        })
        .catch(() => {});
    },
    sendSQ(address, speed) {
      let vm = this;
      vm.requestDialog = false;
      vm.isLoading = true;

      if (address) {
        vm.sendSQRequestNew({ address, speed })
          .then((response) => {
            this.setMessage({
              message: 'SQ Request sent',
              httpStatus: 200,
            });
            vm.lastSQTicket = response.id;
            vm.isLoading = false;
            vm.sqSent = true;
          })
          .catch((err) => {
            vm.isLoading = false;
            new httpError({
              message: 'Unable to send message: ' + err.message,
              httpStatus: 500,
            });
          });
      }
    },
    existingOrder(orderData) {
      let vm = this;
      vm.setIsQuote(orderData.isQuote);
      vm.retrieved = true;
      vm.loading = true;

      this.getOrder(orderData.orderID)
        .then((order) => {
          if (order.orderType === 2) {
            this.$store.commit('orders/changeLessee/setCreateOnly', true);
            vm.loading = false;
          } else {
            if (order) {
              vm.selectedOrderType = order.orderType;
              if (vm.message.httpStatus === 200) {
                if (!vm.isQuote && vm.rows[0].existingCustomer) {
                  vm.getDirectDebit().then(() => {
                    Object.assign(vm.directDebit, vm.rows[0].directDebit);
                  });
                }
                vm.setResidential(
                  order.customerDetails
                    ? order.customerDetails.custType == 'R'
                    : false
                );
                vm.loading = false;
              }
            }
          }
        })
        .catch((err) => {
          vm.setMessage(
            new httpError({
              message: 'Unable to get order: ' + err.message,
              httpStatus: 500,
            })
          );
        });
    },
    closeRetrieve(el) {
      let vm = this;
      vm.dialog = false;
      if (el === true) {
        let redirectpath = `/app-status`;
        if (this.$store.getters['orders/changeLessee/createOnly'])
          redirectpath = '/change-lessee';
        vm.$router.push({
          path: redirectpath,
        });
      } else {
        vm.resetOrder();
      }
    },
    updateAttentionStatus() {
      this.attention = false;
    },
    closeCOLDialog() {
      let vm = this;
      vm.colDialog = false;
      // vm.$router.go();
    },
  },
};
</script>

<style scoped>
.v-btn {
  line-height: 1 !important;
}
</style>
